import { render, staticRenderFns } from "./solutionCard.vue?vue&type=template&id=38efb85e&scoped=true"
import script from "./solutionCard.vue?vue&type=script&lang=js"
export * from "./solutionCard.vue?vue&type=script&lang=js"
import style0 from "./solutionCard.vue?vue&type=style&index=0&id=38efb85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38efb85e",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QImg,QIcon,QTooltip});
